module.exports = __webpack_public_path__ + "static/media/logoShearlyI.4518e957.png";